
import TableList from "@components/templates/tablelist";
import { HttpPlanDeliverList } from "@/service/allotment";
export default {
    props: ['isSearch'],
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: this.isSearch,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    created() {
        if (!this.isSearch) this.updateSearch();
    },
    methods: {
        ajaxRequest: HttpPlanDeliverList,
    },
    computed: {
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_sku',
                show: true,
            }]
        },
        columns() {
            return [
                {
                    title: 'ERP SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.alloment.plan_out_bound', { defaultValue: '计划出库数量' }),
                    key: 'qty',
                },
                {
                    title: this.$t('fbb.alloment.has_boxing', { defaultValue: '已装箱数量' }),
                    key: 'qtyPacked',
                }, {
                    title: this.$t('global.common.operation', { defaultValue: "操作" }),
                    width: this.isSearch ? 120 : 0,
                    align: 'center',
                    render: (h, { row }) => {
                        return h('vButton', {
                            props: {
                                theme: 'primary'
                            },
                            nativeOn: {
                                click: () => {
                                    this.$emit('on-data', { sku: row.sku, qty: row.inventoryAvailable, productId: row.productId })
                                }
                            }
                        }, this,$t('fbb.inbound.choose', { defaultValue: "选择" }))
                    }
                }
            ];
        },

    },

};
